import { UploadMutlipleFileRequest } from './../../features/transport-operation/components/file-management/interface/upload-mutliple-file-request';
import { FileUploadResponse } from './../models/transport-operation/file-upload-response';
import { FileUploadRequest } from './../models/transport-operation/file-upload-request';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DownloadPdfRequest } from '../models/transport-operation/download-pdf-request';
import { isNullOrEmpty } from '../utils/common-functions';
import { DownloadMergeFileRequset } from 'src/app/core/models/transport-operation/download-merge-file-request';

@Injectable({
  providedIn: 'root'
})
export class ShippingDocumentService {

  constructor(private http: HttpClient) { }

  /**
   * get DocType Options
   */
  getDocumentOptions(language: string, doNo: string,
    fileType: string): Observable<any> {
    if(fileType == "Booking"){
      const url = `${environment.logisticsApiUrl}/shippingDocument/documentOptions/booking/${language}/${doNo}`;
      return this.http.get(url);
    }else{
      const url = `${environment.logisticsApiUrl}/shippingDocument/documentOptions/${language}/${doNo}`;
      return this.http.get(url);
    }
  }

  /**
   * get DocTypes by category
   */
  getDocumentTypes(category?: number): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/documentTypes/${isNullOrEmpty(category) ? '' : category}`;
    return this.http.get(url);
  }

  getDocumentTypesByCategories(categories: number[]): Observable<any>{
    const url = `${environment.logisticsApiUrl}/shippingDocument/documentTypes`;
    return this.http.post(url, categories);
  }

  /**
   * get all docs by doNo
   */
  getDocs(filter: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/shippingDocument/document/search`;
    let options = {
      observe: 'response' as 'response',
      responseType: 'json' as 'text'
    }
    return this.http.post(url, filter, options);
  }

  /**
   *
   * @param file upload file
   * @param model file information
   */
  uploadFile(file: any, model: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/shippingDocument/document`;

    const formData: FormData = new FormData();
    model.operatorName = encodeURI(model.operatorName);
    formData.append('json', JSON.stringify(model));
    formData.append('file', file, file.name);

    let response = this.http.put(url, formData, { reportProgress: true, observe: 'events' });
    return response;
  }

  /**
   * delete file
   * @param seqNo delete key
   */
  deleteFile(seqNo: number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/shippingDocument/${seqNo}`;
    return this.http.delete(url);
  }

  downloadDocument(docType: string, referenceType: string, referenceKey: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/attachFile`;
    return this.http.post(url, [{ docType, referenceType,  referenceKey: [referenceKey] }]);
  }

  downloadDocuments(docType: string, referenceType: string, referenceKeys: string[], loginAccount: string, isAllowRemovePrinted: boolean, remark: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/attachFile`;
    return this.http.post(url, [{ docType, referenceType, referenceKey: referenceKeys, userId: loginAccount, isRemovePrintedDoc: isAllowRemovePrinted, remark: remark }]);
  }

  downloadChinaExportDocument(params:any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/attachChinaExportDeclarationFile`;
    return this.http.post(url, params, { responseType: 'blob' });
  }

  searchProofOfDelivery(bookingNo: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/proofOfDelivery/search/${bookingNo}`;
    return this.http.post(url, bookingNo);
  }

  downloadPdf(request: DownloadPdfRequest): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/download/pdf`;
    return this.http.post(url, request);
  }

  downloadZip(request: DownloadPdfRequest): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/download/zip`;
    return this.http.post(url, request);
  }

  uploadDocuments(request: FileUploadRequest): Observable<FileUploadResponse[]> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/documents`;
    return this.http.put<FileUploadResponse[]>(url, request);
  }

  downloadMergeFile(params: DownloadMergeFileRequset): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/download/mergeFile`;
    return this.http.post(url, params);
  }

  uploadMutlipleDocuments(request: UploadMutlipleFileRequest): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/uploadMutlipleDocuments`;
    return this.http.put<FileUploadResponse[]>(url, request);
  }

  uploadMutlipleDocumentsWithVersionControl(request: UploadMutlipleFileRequest, isVersionControl: boolean): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/uploadMutlipleDocuments?isVersionControl=${isVersionControl}`;
    return this.http.put<FileUploadResponse[]>(url, request);
  }

  retrieveShippingDocumentFiles(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/retrieveShippingDocumentFiles`;
    return this.http.post<FileUploadResponse[]>(url, request);
  }

  /**
   * delete file
   * @param sn delete key
   */
  deleteFileBySnCode(sn: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/shippingDocument/deleteBy/${sn}`;
    return this.http.delete(url);
  }
}
